import axios from "axios"
import { Token } from "../urlParams"
import { REACT_APP_USER_API_URL } from "../../envVariables";
export interface UserProps {
    wallets: wallets[];
    id:number;
    
  }

  type wallets={
    id:number
 amount:number
 currency:{
  code:string;
  symbol:string
}
  }
interface ResponseData {
    data: {
      user: UserProps;
    };
  }

export const getUser=async()=>{
    try {
      const responce=await axios.get(`${REACT_APP_USER_API_URL}user/get-user` ,{
        headers: {
          'Authorization': `AccessToken=${Token}`,
          'Content-Type': 'application/json', 
        }
      })
  return responce.data.data.user
    }catch(err){
      console.log('getting error get user',err)
    }
  }
export const getZegoToken=async(drawId:number)=>{
    try {
      // const response=await axios.get(`http://localhost:7004/api/v1/lottery/get-zego-token` ,{
      const response=await axios.get(`${REACT_APP_USER_API_URL}lottery/get-zego-token` ,{
        headers: {
          'Authorization': `AccessToken=${Token}`,
          'Content-Type': 'application/json', 
        },
        params:{drawId}
      })
     return response.data.data
    }catch(err){
      console.log('getting error get user',err)
    }
  }